import styled from "styled-components";
import { Button } from "../../../components";
import { colors } from "../../../consts";
import { TableWrapper } from "../../../components/Table/styled";

export const OpenAppButton = styled(Button)`
  height: 40px;
  padding: 0 24px 0 24px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  border: 1px solid;

  gap: 4px;

  &:active {
    svg {
      path {
        fill: ${colors.ISABELLINE};
      }
    }
  }
`;

export const AppsTableWrapper = styled.div`
  ${TableWrapper} {
    overflow: visible;
  }
`;
